export default __webpack_public_path__ + "static/media/adminDelete.0fc6c926.svg";